import { render, staticRenderFns } from "./Currency.vue?vue&type=template&id=4f4cff5a&scoped=true"
import script from "./Currency.vue?vue&type=script&lang=js"
export * from "./Currency.vue?vue&type=script&lang=js"
import style0 from "./Currency.vue?vue&type=style&index=0&id=4f4cff5a&prod&lang=scss"
import style1 from "./Currency.vue?vue&type=style&index=1&id=4f4cff5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4cff5a",
  null
  
)

export default component.exports